module.exports = __webpack_public_path__ + "media/images/instagram-b133e565e26031a4181b82e6a67d7c65.svg";